import { useAppSelector } from 'src/hooks';
import DrawerBase from '../../../planner/components/drawer/drawer';
import DRAWER_VIEW_TYPE from '../../../planner/types/drawer-view-type';

/**
 * Drawer container which will renders the side drawer for a selected product (PPG or SKU)
 */
function DrawerBoxContainer() {
  const { isDisplayComments } = useAppSelector((state) => state.drawerManager);

  return (
    <DrawerBase
      open={isDisplayComments}
      viewType={DRAWER_VIEW_TYPE.TABLE_COMMENT_BOX}
      isFooterVisible={false}
    />
  );
}

export default DrawerBoxContainer;
